import { ReactElement, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { AddOnComponent } from "../../ui/molecules/addOnComponent";
import { AddOnPopup } from "../../ui/molecules/addOnPopup";
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import { MadfarmInput } from "../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import {
  campo_di_applicazione,
  categorie_piante,
  edizioni,
  global_standards,
  manipolazione,
  opzioni_certificazione_CoC,
  opzioni_certificazione_IFA,
  yes_no,
} from "../../utils";
import { deleteAddOn, getAddOnById } from "../clienti/feature/addOn/slice";
import { setCustomerCreateRequestField, setCustomerUpdateRequestField } from "../clienti/feature/slice";
import {
  setGgn
} from "../clienti/slice";

interface Props {
  title?: string;
  placeholder?: string;
  defaultValue: any;
  value: any;
  options: {
    value: string;
    label: string;
  }[];
  onChangeHandler: (value: string | undefined) => void;
  noOptions?: string | "Nessun risultato trovato";
}

const CustomSelectComponent = (props: Props): ReactElement => {
  const { title, placeholder, defaultValue, value, options, onChangeHandler, noOptions } =
    props;

  return (
    <>
      <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">{title}</span>
      <MadfarmStaticSelect
        placeholder={placeholder || ""}
        defaultValue={defaultValue}
        value={value}
        options={options}
        onChange={(value) => {
          //@ts-ignore
          const newValue = value !== null ? value.value : undefined;
          onChangeHandler(newValue);
        }}
        noOptionsMessage={noOptions!}
      />
    </>

  );
};

interface GlobalGapProps {
  mode?: "create" | "edit"
  customerId?: string | number;
}

export function GlobalGap({ mode, customerId }: GlobalGapProps) {
  const customerState = useAppSelector((state) => state.customer);
  const addOnState = useAppSelector((state) => state.addOn);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      customerState.getCustomerByIdStatus === "successfully" &&
      customerState.getCustomerByIdResponse !== undefined
    ) {
      if (customerState.getCustomerByIdResponse.ggAddOnsId && customerState.getCustomerByIdResponse.ggAddOnsId.length > 0) {
        customerState.getCustomerByIdResponse.ggAddOnsId.map(id => dispatch(getAddOnById(id)));
      }

    }
  }, [customerState.getCustomerByIdStatus]);

  useEffect(() => {
    if (addOnState.getAddOnByIdStatus === 'successfully' &&
      addOnState.getAddOnByIdResponse !== undefined
    ) {
      dispatch(setCustomerUpdateRequestField({ field: "ggAddOns", value: [...(customerState.customerUpdateRequest?.ggAddOns || []), addOnState.getAddOnByIdResponse] }))
    }
  }, [addOnState.getAddOnByIdStatus])

  // useEffect(() => {
  //   if (clientiState.getAddOnsStatus === 'successfully' &&
  //     clientiState.getAddOnsResponse !== undefined
  //   ) {
  //     dispatch(resetGetAddOnsStatus());
  //     clientiState.getAddOnsResponse.data.map(addOn => {
  //       if (addOn.customerDataId === clientiState.selectedCustomerId)
  //         dispatch(addCustomAddOn(addOn));
  //     })
  //   }
  // })

  // useEffect(() => {
  //   if (clientiState.deleteAddOnStatus === 'successfully') {
  //     dispatch(resetDeleteAddOnStatus());
  //     dispatch(setAddOns([]));
  //     dispatch(GetAddOns());
  //   }
  // }, [clientiState.deleteAddOnStatus])

  const [showPopup, setShowPopup] = useState<boolean>(false);

  const customerCreateOrEditRequest = mode === "create" ? customerState.customerCreateRequest! : customerState.customerUpdateRequest!;

  return (
    <div className="flex flex-col gap-3 border-t border-neutral-200 pt-6">
      <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">GGN</span>
      <MadfarmInput
        value={customerCreateOrEditRequest.ggGgn ?? ""}
        placeholder="GGN"
        onChangeText={(text) => {
          if (mode === "create") {
            dispatch(setCustomerCreateRequestField({ field: "ggGgn", value: text }))
          } else {
            dispatch(setCustomerUpdateRequestField({ field: "ggGgn", value: text }))
          }
          dispatch(setGgn(text))
        }}
      />
      <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">STANDARD</span>
      <MadfarmStaticSelect
        placeholder="Standard"
        defaultValue={customerCreateOrEditRequest.ggStandard}
        value={customerCreateOrEditRequest.ggStandard}
        options={global_standards}
        onChange={(value) => {
          //@ts-ignore
          const newValue = value !== null ? value.value : undefined;
          if (mode === "create") {
            dispatch(setCustomerCreateRequestField({ field: "ggStandard", value: newValue }))
          } else {
            dispatch(setCustomerUpdateRequestField({ field: "ggStandard", value: newValue }))
          }
        }}
        noOptionsMessage={"Nessun risultato trovato"}
      />
      {
        customerCreateOrEditRequest.ggStandard === "IFA" && (
          <div className="flex flex-col gap-3">
            <CustomSelectComponent
              title="Edizione"
              placeholder="Seleziona edizione..."
              defaultValue={customerCreateOrEditRequest.ggEdition}
              value={customerCreateOrEditRequest.ggEdition}
              options={edizioni}
              onChangeHandler={(value) => {
                if (mode === "create")
                  dispatch(setCustomerCreateRequestField({ field: "ggEdition", value }))
                else
                  dispatch(setCustomerUpdateRequestField({ field: "ggEdition", value }))
              }}
            />
            <CustomSelectComponent
              title="Campo di applicazione"
              placeholder="Seleziona campo di applicazione..."
              defaultValue={
                customerCreateOrEditRequest.ggApplicationField
              }
              value={customerCreateOrEditRequest.ggApplicationField}
              options={campo_di_applicazione}
              onChangeHandler={(value) => {
                if (mode === "create")
                  dispatch(setCustomerCreateRequestField({ field: "ggApplicationField", value }))
                else
                  dispatch(setCustomerUpdateRequestField({ field: "ggApplicationField", value }))
              }}
            />
            {
              customerCreateOrEditRequest.ggApplicationField === "PIANTE" &&
              <CustomSelectComponent
                title="Categoria"
                placeholder="Seleziona categoria..."
                defaultValue={customerCreateOrEditRequest.ggCategory}
                value={customerCreateOrEditRequest.ggCategory}
                options={categorie_piante}
                onChangeHandler={(value) => {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggCategory", value }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggCategory", value }))
                }}
              />
            }
            <CustomSelectComponent
              title="Opzioni per la Certificazione"
              placeholder="Seleziona opzione..."
              defaultValue={
                customerCreateOrEditRequest.ggIFACertificationOption
              }
              value={
                customerCreateOrEditRequest.ggIFACertificationOption
              }
              options={opzioni_certificazione_IFA}
              onChangeHandler={(value) => {
                if (mode === "create")
                  dispatch(setCustomerCreateRequestField({ field: "ggIFACertificationOption", value }))
                else
                  dispatch(setCustomerUpdateRequestField({ field: "ggIFACertificationOption", value }))
              }}
            />
            <CustomSelectComponent
              title="Manipolazione"
              placeholder="Seleziona manipolazione..."
              defaultValue={customerCreateOrEditRequest.ggManipulation}
              value={customerCreateOrEditRequest.ggManipulation}
              options={manipolazione}
              onChangeHandler={(value) => {
                if (mode === "create")
                  dispatch(setCustomerCreateRequestField({ field: "ggManipulation", value }))
                else
                  dispatch(setCustomerUpdateRequestField({ field: "ggManipulation", value }))
              }}
            />
            <CustomSelectComponent
              title="Proprietà parallele"
              placeholder="Seleziona proprietà..."
              defaultValue={
                customerCreateOrEditRequest.ggParallelProperty
                  ? "SI"
                  : ""
              }
              value={
                customerCreateOrEditRequest.ggParallelProperty
                  ? "SI"
                  : ""
              }
              options={yes_no}
              onChangeHandler={(value) => {
                if (value === "SI") {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggParallelProperty", value: true }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggParallelProperty", value: true }))
                } else {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggParallelProperty", value: false }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggParallelProperty", value: false }))
                }
              }}
            />
            <div className="border h-[1px] border-neutral-200" />
            <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
              ADD-ON (MODULI AGGIUNTIVI)
            </span>
            {customerCreateOrEditRequest.ggAddOns?.map((add, index) => (
              <AddOnComponent
                key={index}
                idx={index}
                id={Number(add.id)}
                onEdit
                mode={mode}
                customerId={customerId}
                title={add.addModule}
                startDate={add.starting}
                endDate={add.ending}
                note={add.addOn}
                onDelete={() => {
                  if (mode === "edit" && add.id) {
                    dispatch(deleteAddOn(String(add.id)));
                    const updated = [...(customerCreateOrEditRequest.ggAddOns || [])];
                    updated.splice(index, 1);
                    dispatch(setCustomerUpdateRequestField({ field: "ggAddOns", value: updated }));
                  } else {
                    const updated = [...(customerCreateOrEditRequest.ggAddOns || [])];
                    updated.splice(index, 1);
                    dispatch(setCustomerCreateRequestField({ field: "ggAddOns", value: updated }));
                  }
                }}
              />
            ))}
            <div>
              <ButtonComponent
                size="sm"
                iconPosition="off"
                variant="outline"
                label="Aggiungi Add-on"
                color="blue"
                onClick={() => setShowPopup(true)}
              />
            </div>
            {showPopup && (
              <AddOnPopup
                mode={mode}
                customerId={customerId}
                closeHandler={() => setShowPopup(false)}
              />
            )}
          </div>
        )}
      {
        customerCreateOrEditRequest.ggStandard === "CoC" && (
          <div className="flex flex-col gap-4">
            <CustomSelectComponent
              title="Opzioni per la Certificazione"
              placeholder="Seleziona opzione..."
              defaultValue={customerCreateOrEditRequest.ggCOCCertificationOption}
              value={customerCreateOrEditRequest.ggCOCCertificationOption}
              options={opzioni_certificazione_CoC}
              onChangeHandler={(value) => {
                if (mode === "create")
                  dispatch(setCustomerCreateRequestField({ field: "ggCOCCertificationOption", value }))
                else
                  dispatch(setCustomerUpdateRequestField({ field: "ggCOCCertificationOption", value }))
              }}
            />
            <CustomSelectComponent
              title="Proprietà parallele"
              placeholder="Seleziona proprietà..."
              defaultValue={customerCreateOrEditRequest.ggParallelProperty}
              value={customerCreateOrEditRequest.ggParallelProperty}
              options={yes_no}
              onChangeHandler={(value) => {
                if (value === "SI") {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggParallelProperty", value: true }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggParallelProperty", value: true }))
                } else {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggParallelProperty", value: false }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggParallelProperty", value: false }))
                }
              }}
            />
            <CustomSelectComponent
              title="Etichettatura"
              placeholder="Seleziona etichettatura..."
              defaultValue={customerCreateOrEditRequest.ggLabelling}
              value={customerCreateOrEditRequest.ggLabelling}
              options={yes_no}
              onChangeHandler={(value) => {
                if (value === "SI") {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggLabelling", value: true }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggLabelling", value: true }))
                } else {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggLabelling", value: false }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggLabelling", value: false }))
                }
              }}
            />
            <CustomSelectComponent
              title="Licenza per “GNN Label Logo”"
              placeholder="Seleziona licenza..."
              defaultValue={customerCreateOrEditRequest.ggLicenseGnnLabelLogo}
              value={customerCreateOrEditRequest.ggLicenseGnnLabelLogo}
              options={yes_no}
              onChangeHandler={(value) => {
                if (value === "SI") {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggLicenseGnnLabelLogo", value: true }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggLicenseGnnLabelLogo", value: true }))
                } else {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggLicenseGnnLabelLogo", value: false }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggLicenseGnnLabelLogo", value: false }))
                }
              }}
            />
            <CustomSelectComponent
              title="Trasformazione parziale"
              placeholder="Seleziona trasformazione..."
              defaultValue={customerCreateOrEditRequest.ggPartialTransformation}
              value={customerCreateOrEditRequest.ggPartialTransformation}
              options={yes_no}
              onChangeHandler={(value) => {
                if (value === "SI") {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggPartialTransformation", value: true }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggPartialTransformation", value: true }))
                } else {
                  if (mode === "create")
                    dispatch(setCustomerCreateRequestField({ field: "ggPartialTransformation", value: false }))
                  else
                    dispatch(setCustomerUpdateRequestField({ field: "ggPartialTransformation", value: false }))
                }
              }}
            />
          </div>
        )}
    </div>
  );
}
